import React from "react";
import { Card } from "@yleisradio/areena-types";
import styled from "styled-components";

import { recommendationTextColor } from "../../styles/variables";
import { RecommendationCard } from "../recommendations/RecommendationCard";
import {
  BackgroundGradient,
  RecommendationBackground,
  RecommendationCardTitle,
  RecommendationItemBackground,
  RecommendationList,
  smallHeaderFont,
  watchNext
} from "../recommendations/RecommendationStyles";
import { CommonCardProps } from "../recommendations/recommendationTypes";

const RecommendationListContainer = styled.div`
  margin: 0 0 60px;
  position: absolute;
  width: 100%;
`;

const SmallUiRecommendationList = styled(RecommendationList)`
  flex-wrap: nowrap;
  margin: 0 20px;
  overflow-x: auto;
`;

const Absolute = styled.div`
  position: absolute;
  width: 100%;
`;

const RecommendationsHeader = styled(RecommendationCardTitle)<{
  newPlayerUi: boolean;
}>`
  &&& {
    color: ${recommendationTextColor};
    margin: ${props => (props.newPlayerUi ? "46px 20px; 0.3em" : "0.3em 20px;")}
      ${smallHeaderFont};
  }
`;

export const SmallEndRecommendations = ({
  commonCardProps,
  onClickRecommendation,
  onClickRecommendationPlay,
  onViewRecommendation,
  recommendations
}: {
  recommendations: Card[];
  commonCardProps: CommonCardProps;
  onViewRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendationPlay: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
}) => (
  <RecommendationBackground>
    <Absolute>
      <RecommendationItemBackground image={recommendations[0].image} />
    </Absolute>
    <BackgroundGradient />
    <RecommendationsHeader newPlayerUi={commonCardProps.newPlayerUi}>
      {watchNext(commonCardProps.language)}
    </RecommendationsHeader>
    <RecommendationListContainer>
      <SmallUiRecommendationList>
        {recommendations.map((recommendation, index) => (
          <RecommendationCard
            key={`end-small-recommendation-${index}`}
            onView={viewUuid =>
              onViewRecommendation(recommendation, index, viewUuid)
            }
            onClick={viewUuid =>
              onClickRecommendation(recommendation, index, viewUuid)
            }
            onClickPlay={viewUuid =>
              onClickRecommendationPlay(recommendation, index, viewUuid)
            }
            {...{
              ...commonCardProps,
              index,
              recommendation
            }}
          />
        ))}
      </SmallUiRecommendationList>
    </RecommendationListContainer>
  </RecommendationBackground>
);
